import React from "react";
import PageHeader from "../common/PageHeader";
import { useParams } from "react-router";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useSelector } from "react-redux";
import SupportLink from "../root/support/components/SupportLink";
import PeriodsList from "./PeriodsList";
import CondominiumPeriodList from "./CondominiumPeriodList";
import OnboardingBanner from "../onboarding/OnboardingBanner";

const Periods = () => {
  const { id } = useParams();
  const { all } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);

  return (
    <>
      <PageHeader
        title="Periodos"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
        description={
          role === "manager"
            ? "Gestiona cada uno de tus períodos."
            : "Períodos de tu condominio"
        }
      >
        <SupportLink />
      </PageHeader>

      <OnboardingBanner steps={["periods"]} />

      {role === "manager" && all && <PeriodsList showPagination={true} />}
      {role === 'manager' && selectedCondominium && !id && !all && <CondominiumPeriodList condominiumId={selectedCondominium} showPagination={true} />}
      {/*             {role === 'manager' && id && <CondominiumBankList condominiumId={id} showPagination={true} />}
            {role === 'manager' && id && selectedCondominium && <CondominiumBankList condominiumId={id} showPagination={true} />}
            {role === 'manager' && selectedCondominium && !id && !all && <CondominiumBankList condominiumId={selectedCondominium} showPagination={true} />}
            {role === 'property' && <CondominiumBankList condominiumId={selectedCondominium} showPagination={true} />} */}
    </>
  );
};

export default withRedirect(Periods);
